const pathsToHide = ['/password']

const config = { childList: true };

document.addEventListener('DOMContentLoaded', () => {
    const targetNode = document.querySelector('body.password')
    const pathname = window.location.pathname
    
    const hideModalForCurrentRoute = pathsToHide.some((pathToHide) => pathname.includes(pathToHide))

    if (!targetNode || !hideModalForCurrentRoute) {
        return
    }

    const callback = (mutationList, observer) => {
        for (const mutation of mutationList) {
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach((node) => {
                    if (node.classList.contains('frcp-loyalty-launcher-wrapper')) {
                        node.classList.add('hidden')
                        observer.disconnect()
                    }
                })
            }
        }
    };

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
})